import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  CloudAppAvalibility,
  CloudAppSecurity,
  CloudAppInteroperability,
  CloudAppCompliance,
  CloudAppScale,
  CloudAppPerformance,
} from "../../../app-constants";

function Workflowprocess() {
  return (
    <section
      className="workflow_process cloud_app_process p-100"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Vital Elements of Our Cloud Application Development Company</h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="my-auto">
            <div className="workflow_main">
              <div className="workflow_process_item">
                <div className="workflow_process_img">{CloudAppScale}</div>
                <div className="workflow_process_content">
                  <h5>Scalability</h5>
                  <p>
                    To implement high availability, we have designed our cloud
                    applications to auto-scale as necessary based on the
                    workload.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{CloudAppSecurity}</div>
                <div className="workflow_process_content">
                  <h5>Security</h5>
                  <p>
                    We use protection systems such as information encryption,
                    Identity, and access management as well as periodic
                    evaluation for possible entry points for the attackers.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">
                  {CloudAppAvalibility}
                </div>
                <div className="workflow_process_content">
                  <h5>High Availability</h5>
                  <p>
                    Using redundant architecture and built-in fail-safe
                    mechanisms, our applications ensure short periods of planned
                    and unplanned outages.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">
                  {CloudAppPerformance}
                </div>
                <div className="workflow_process_content">
                  <h5>Performance Optimization</h5>
                  <p>
                    Project performance is being controlled on a real-time basis
                    using modern metrics gathering systems (i.e.,
                    Prometheus/Grafana) and optimized as required.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">
                  {CloudAppInteroperability}
                </div>
                <div className="workflow_process_content">
                  <h5>Interoperability</h5>
                  <p>
                    Our cloud solutions are developed with strong APIs and
                    integration characteristics which allow for smooth
                    interaction with other applications and services.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{CloudAppCompliance}</div>
                <div className="workflow_process_content">
                  <h5>Compliance</h5>
                  <p>
                    Our applications are built to meet the requirements of the
                    current standards and policies like GDPR, HIPAA, and others
                    to ensure that your business runs smoothly.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Workflowprocess;
